// schemas/department.ts
import { z } from 'zod'

// 创建部门 Schema (匹配后端 CreateDepartmentRequest)
export const createDepartmentSchema = z.object({
  name: z
    .string()
    .min(1, '部门名称不能为空')
    .max(64, '部门名称不能超过64个字符'),
  description: z
    .string()
    .max(255, '部门说明不能超过255个字符')
    .optional()
    .or(z.literal('')),
  parent_id: z.number().optional().nullable(),
  status: z.number().optional(),
})

export type CreateDepartmentFormData = z.infer<typeof createDepartmentSchema>

// 编辑部门 Schema (匹配后端 UpdateDepartmentRequest)
export const updateDepartmentSchema = z.object({
  name: z
    .string()
    .min(1, '部门名称不能为空')
    .max(64, '部门名称不能超过64个字符'),
  description: z
    .string()
    .max(255, '部门说明不能超过255个字符')
    .optional()
    .or(z.literal('')),
  status: z.number().optional(),
})

export type UpdateDepartmentFormData = z.infer<typeof updateDepartmentSchema>

// 添加用户到部门 Schema
export const addUsersToDepartmentSchema = z.object({
  user_ids: z
    .array(z.number())
    .min(1, '请至少选择一个用户'),
})

export type AddUsersFormData = z.infer<typeof addUsersToDepartmentSchema>
